var map = {
	"./100.jpg": 621,
	"./100.png": 7453,
	"./Microsoft_logo.svg.png": 2432,
	"./Siksha_‘O’_Anusandhan.png": 4988,
	"./aws.png": 9967,
	"./azure.png": 5497,
	"./b.png": 1446,
	"./buld.jpg": 4281,
	"./codeInLogo.png": 7873,
	"./codeuino.jpg": 8314,
	"./codexiter.png": 935,
	"./congle.png": 6064,
	"./coursera_logo.png": 1170,
	"./cra.png": 1568,
	"./dal.png": 9071,
	"./deeplearning_ai_logo.png": 9575,
	"./freelance.jpg": 8711,
	"./googleAssistant.jpg": 1659,
	"./google_logo.png": 9389,
	"./ino.png": 7192,
	"./intel_logo.jpg": 8504,
	"./quicko.jpg": 6458,
	"./rohan.jpg": 2642,
	"./sal.png": 5016,
	"./samsung.png": 4428,
	"./siemens.png": 1342,
	"./stanford_logo.png": 6691,
	"./vjt.png": 5756,
	"./wrighter.jpg": 8296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;